import { IInitAction } from './init'
import { IGroup } from './group'

// Action types
export enum types {
  GET_GROUPS__STARTED = 'GET_GROUPS__STARTED',
  GET_GROUPS__SUCCESS = 'GET_GROUPS__SUCCESS',
  GET_GROUPS__FAILURE = 'GET_GROUPS__FAILURE',
}

export interface IGetGroupsAction {
  type: types.GET_GROUPS__STARTED
}

export interface IGetGroupsSuccessAction {
  type: types.GET_GROUPS__SUCCESS
  list: IGroup[]
}

export interface IFailureAction {
  type: types.GET_GROUPS__FAILURE
  message: string
}

export type GroupsActionsType =
  | IGetGroupsAction
  | IGetGroupsSuccessAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface IGroups {
  isLoading: boolean
  isLoaded: boolean
  list: IGroup[]
}
